export default (props, inject) => {
  const getProductName = function (product) {
    const name = '';
    const char = productChar(product);

    console.log('product: ', product);

    return name;
  };

  inject('getProductName', getProductName);
};

const productChar = (product) => {
  const shortCharacteristics = product?.shortCharacteristics || [];
  if (shortCharacteristics.length <= 0) {
    return;
  }

  const name = [];

  const disksize = shortCharacteristics.find((t) => t.slug === 'disksize');
  if (disksize) {
    name.push(disksize?.values?.[0]?.value || '');
  }

  const pcdBoltcount = shortCharacteristics.find((t) => t.slug === 'pcd-boltcount');
  if (pcdBoltcount) {
    name.push(pcdBoltcount?.values?.[0]?.value || '');
  }

  return name.filter((t) => !!t).join(', ');
};
